import React from 'react';
import type { DataTypeKey } from './sensorUtils';

export const DATA_TYPE_TOOLTIPS: Record<DataTypeKey, React.ReactNode> = {
  Presence:
    'Detects people within a space and estimates occupancy across the coverage area, including stationary occupants.',
  Motion:
    'Detects whether a space is occupied based on movement. Outputs a simple occupied / unoccupied signal.',
  'PIR Zeroing':
    'Combines traffic counting with presence or motion detection. Resets occupancy to zero when the space is confirmed empty to maintain accuracy.',
  Traffic: (
    <div>
      <div>Counts people entering and exiting a space.</div>
      <ul style={{ margin: '8px 0 0', paddingLeft: 16, listStyleType: 'disc' }}>
        <li>Can estimate occupancy, but inferred (drift-prone)</li>
        <li>Shown historically (after calibration), not live</li>
      </ul>
    </div>
  ),
  Desk: 'Detects desk occupancy and provides availability insights.',
};
